
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Finalizing_Choice = class Notification_Finalizing_Choice {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _finalizing_modal_init = false;
    static _finalizing_modal_action = null;

    static _is_final_approval = false;
    static _picks = false;
    static _rejected = null;
    static _rejection_reason = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;

        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.is_final_approval) {
                this._is_final_approval = true;
            }
            if (meta.picks) {
                this._picks = meta.picks;
            }
            if (meta.rejected) {
                this._rejected = true;
            }
            if (meta.rejection_reason) {
                this._rejection_reason = meta.rejection_reason;
            }
        } catch (e) {
        }

        // await _.sleep(1000);

        // Ensure we have accurate data.

        // This is SLOW and we really should figure out how to make sure we will have
        // all the data we need, or a faster way to do data_sync.
        await _.data_sync();

        if (this._is_final_approval) {
            this.final_approval_dialog();
        } else {
            this.finalize_choice_round_modal();
        }
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
        _.Modal.close_unhidable();
    }

    /**
     * The round the winner picks for: the auction's current (finalizing) round, not the round the page is
     * showing (a sold tract shows the round it sold on).
     */
    async pick_round() {
        return await _.ac_state.auction.current_round.fetch_private();
    }

    async finalize_choice_round_modal() {
        let that = this;
        let $modal = $("#ac-modal-finalizing-choice");

        console.log("Showing finalize choice round modal.");

        let current_round = await that.pick_round();

        // One watcher per notification (re-opening the box after cancel / go back used to add another)
        clearInterval(that._round_state_check);
        that._round_state_check = setInterval(async function () {
            let round = await that.pick_round();
            if (!round || round.id != current_round.id || round.status != App_Models_AuctionRound.STATUS_FINALIZING) {
                if ($("#ac-modal-finalizing-choice").is(":visible")) {
                    _.Modal.close_unhidable();
                }
                if (!$("#ac-modal-finalizing-choice").is(":visible")) {
                    clearInterval(that._round_state_check);
                }
            }
        }, 1000);

        let high_bid = await current_round.current_bid.fetch_private();

        // Todo: Sometimes this popup happens before session loaded

        // if (!high_bid || high_bid.registrant_id != _.ac_state.registrant.id) {
        //     _.shouldnt_happen();
        //     return;
        // }

        $(".ac-modal-finalizing-choice-current-bid").text(_.currency(high_bid.amount));
        $(".ac-modal-finalizing-choice-roundnumber").text(current_round.round_number);

        $("#ac-modal-finalizing-choice-justwon-notice").show();
        $("#ac-modal-finalizing-choice-rejection-notice-no-reason").hide();
        $("#ac-modal-finalizing-choice-rejection-notice-with-reason").hide();

        if (this._rejected) {
            $("#ac-modal-finalizing-choice-justwon-notice").hide();
            if (this._rejection_reason) {
                $("#ac-modal-finalizing-choice-rejection-notice-with-reason").show();
                $("#ac-modal-finalizing-choice-rejection-reason").text(this._rejection_reason);
            } else {
                $("#ac-modal-finalizing-choice-rejection-notice-no-reason").show();
            }
        }

        function populateCheckboxes(auctionItems) {
            let $checkboxContainer = $(".ac-modal-finalizing-choice-select-items ul");
            $checkboxContainer.empty();

            auctionItems.forEach(item => {
                let id = item.id + "_finalize_selector";

                let $checkbox = $('<input>').attr({
                    type: 'checkbox',
                    value: 1,
                    id: id,
                    class: 'form-check-input'
                }).on('change', updateSelectedItemsList)
                    .data('item', item);

                let item_text = item.title + " - " + item.acres +
                    " " + _.property_noun_unit_plural_plusminus() + ", " + _.currency(high_bid.amount * item.acres) + "";

                let $label = $('<label>')
                    .attr('for', id)
                    .css('width', '100%')
                    .css('height', '100%')
                    .attr('class', 'list-item-multiselect-styling')
                    .text(item_text)
                    .prepend($checkbox);

                let $li = $("<li class='list-group-item'></li>").attr('for', id).append($label);

                $checkboxContainer.append($li);
            });
        }

        function updateSelectedItemsList() {
            let auction = _.ac_state.auction;
            let totalAcres = 0;
            let totalItems = 0;

            $(".ac-modal-finalizing-choice-select-items input:checked").each(function () {
                let item = $(this).data('item');

                if (item.acres) {
                    totalAcres += item.acres;
                }

                totalItems++;
            });

            let salePrice = high_bid.amount;
            let subtotal = salePrice * totalAcres;
            let totalCost = salePrice * totalAcres * (1 + (parseFloat(auction.total_fees) / 100));

            $(".ac-modal-finalizing-choice-lots-acres").text(totalAcres);
            $(".ac-modal-finalizing-choice-lots-count").text(totalItems);
            $(".ac-modal-finalizing-choice-lots-subtotal").text(_.currency(subtotal));
            $(".ac-modal-finalizing-choice-lots-price").text(_.currency(totalCost));

            let $subtotal_container = $(".ac-modal-finalizing-choice-lots-subtotal-container");
            let $fees = $(".ac-modal-finalizing-choice-lots-fees");

            $fees.empty();

            if (auction.total_fees > 0) {
                $fees.show();
                $subtotal_container.show();

                try {
                    let feesArray = JSON.parse(auction.fees || '[]'); // Safely parse the JSON

                    if (feesArray.length > 0) {
                        feesArray.forEach(fee => {
                            $fees.append($("<div>" + fee.amount + "% " + fee.name + ": <strong>" + _.currency(salePrice * totalAcres * (parseFloat(fee.amount) / 100)) + "</strong></div>"))
                        });
                    }
                } catch (e) {
                    console.error(e);
                    $fees.html("<div style='margin:10px; font-style:italic;'>Warning: error calculating auction fees, please confirm prices with LandProz clerk</div>")
                }
            } else {

                $fees.hide();
                $subtotal_container.hide();

            }
        }

        // Get available items
        let auction_items_available = [];

        for (const item of (await _.ac_state.auction.auction_items.fetch_private())) {
            if (item.status == App_Models_AuctionItem.STATUS_AVAILABLE) {
                auction_items_available.push(item);
            }
        }

        populateCheckboxes(auction_items_available);

        updateSelectedItemsList();

        if (!_.Notification_Finalizing_Choice._finalizing_modal_init) {
            _.Notification_Finalizing_Choice._finalizing_modal_init = true;

            $("#ac-modal-finalizing-choice-btn-chat").click(function (e) {
                e.preventDefault();
            });

            $("#ac-modal-finalizing-choice-btn-submit").click(function (e) {
                e.preventDefault();
                that.finalize_choice_round_modal_submit();
            });
        }

        $modal.modal_show();
        _.Modal.set_unhidable();

        // Countdown timer
        let countdown_clock_seconds_remaining = await _.backend_ajax(
            'auctions',
            'finalize_dialog_get_seconds_remain',
            { 'round_id': current_round.id }
        );

        if (!countdown_clock_seconds_remaining) {
            countdown_clock_seconds_remaining = 0;
        }

        _.time.new().add(countdown_clock_seconds_remaining).countdown($(".ac-modal-finalizing-choice-countdown-timer"), "", "", true);
    }

    async finalize_choice_round_modal_submit() {
        let that = this;

        // Collect choices.
        // If no choices alert.
        // Send to clerk.
        // Inform user that choices have been sent to clerk.

        let current_round = await that.pick_round();
        let high_bid = await current_round.current_bid.fetch_private();

        if (!high_bid || high_bid.registrant_id != _.ac_state.registrant.id) {
            _.shouldnt_happen();
            return;
        }

        let picked_items = [];
        let picked_items_ids = [];
        let totalAcres = 0;
        let totalItems = 0;

        $(".ac-modal-finalizing-choice-select-items input:checked").each(function () {
            let item = $(this).data('item');

            if (item.acres) {
                totalAcres += item.acres;
            }

            totalItems++;

            picked_items.push(item);
            picked_items_ids.push(item.id);
        });

        if (picked_items.length == 0) {
            _.Modal.close_unhidable();
            await _.Modal.alert("Please select at least one lot to continue.");
            that.finalize_choice_round_modal();
            return;
        }

        let salePrice = high_bid.amount;
        let subtotal = salePrice * totalAcres;
        let fees = salePrice * totalAcres * (parseFloat(_.ac_state.auction.total_fees) / 100);
        let totalCost = subtotal + fees;

        let confirmation_message = "Please confirm your choices:<br /><br />";

        for (let item of picked_items) {
            confirmation_message += "<b>" + _.htmlescape(item.title) + "</b><br /><br />";
        }

        confirmation_message += "Number of lots: " + totalItems + "<br />";
        confirmation_message += "Total " + _.property_noun_unit_plural_ucwords() + ": " + _.represent_units_with_plusminus(totalAcres) + "<br />";
        confirmation_message += "High Bid: " + _.currency(high_bid.amount) + "<br />";
        if (_.ac_state.auction.total_fees > 0) {
            confirmation_message += "Subtotal: " + _.currency(subtotal) + "<br />";
            confirmation_message += _.ac_state.auction.total_fees + "% buyers fee: " + _.currency(totalCost) + "<br />";
            confirmation_message += "<br /><b>Total price: " + _.currency(totalCost) + "</b><br /><br />";
        } else {
            confirmation_message += "<br /><b>Total price: " + _.currency(totalCost) + "</b><br /><br />";
        }

        _.Modal.close_unhidable();
        _.Modal.set_unhidable();

        if (!(await _.Modal.confirm($("<span>" + confirmation_message + "</span>")))) {
            _.Modal.close_unhidable();
            that.finalize_choice_round_modal();
            return;
        }
        _.Modal.close_unhidable();

        // Todo: send choices.
        try {
            let data = {
                user_choices: picked_items_ids.join(","),
                round_id: current_round.id
            };

            await _.backend_ajax('auctions', 'finalize_choice_round', data);

            // This should trigger a new notification for final approval.
        } catch (e) {
            if (typeof (e) == "string") {
                await _.Modal.alert("There has been an error submitting your picks:\n\n" +
                    e +
                    "\n\nIf you have any questions, please contact the auction manager " + _.ac_state.auction.getContactStringFragment + ".");
            } else {
                await _.Modal.alert("There has been a server error submitting your picks.  Please contact Auction support if you need assistance.");
            }
            that.finalize_choice_round_modal();
        }
    }

    async final_approval_dialog() {
        let picks = []
        if (this._picks) {
            picks = this._picks.split(",");
        }

        let message = "Your choices have been sent to the auction staff for final approval.\n\n";

        for (let pick of picks) {
            let item = await App_Models_AuctionItem.fetch(pick);
            if (item) {
                message += item.title + "\n";
            }
        }

        message += "\nFor additional information on handling your purchase, please\n contact the auction manager " +
            _.ac_state.auction.getContactStringFragment + ".";

        // TODO: make this max width 580 somehow clever.

        _.Modal.close_unhidable();
        await _.Modal.alert(message);
    }
}